var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-0 pt-0 pb-3",attrs:{"id":"nav"}},[_c('h1',[_vm._v("Admin")]),_c('router-link',{attrs:{"to":"/admin/sockets"}},[_vm._v("Sockets")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/admin/stats"}},[_vm._v("Stats")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }